
import { Vue, Options, prop } from "vue-class-component";
import { AccountController } from '../../controllers/AccountController';

class Props {
  show = prop<boolean>({
    default: false,
    type: Boolean
  });
}

@Options({
  name: "ModalOtpActivation",
  emits: ["activate", "skip"]
})
export default class ModalOtpActivation extends Vue.with(Props) {
  get isCountryCodeEmpty() {
    return !AccountController.accountData.countryCode;
  }
}
